import { X, ZoomIn } from "lucide-react";
import { useEffect, useState } from "react";
import "./FrameRealGallery.css";

export default function FrameRealGallery({
  images,
  title = "Asi queda en la vida real",
  description = "Ideas reales para imaginar como quedara tu marco.",
}) {
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    if (!activeImage) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setActiveImage(null);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [activeImage]);

  if (!images?.length) return null;

  return (
    <>
      <section className="frame-real-gallery" aria-labelledby="frame-real-gallery-title">
        <div className="frame-real-gallery__heading">
          <h2 id="frame-real-gallery-title">{title}</h2>
          <p>{description}</p>
        </div>

        <div className="frame-real-gallery__track">
          {images.map((image) => (
            <button
              key={image.src}
              type="button"
              className="frame-real-gallery__item"
              onClick={() => setActiveImage(image)}
              aria-label={`Ampliar: ${image.alt}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                loading="lazy"
                decoding="async"
              />
              <span aria-hidden="true">
                <ZoomIn />
              </span>
            </button>
          ))}
        </div>
      </section>

      {activeImage && (
        <div
          className="frame-real-gallery-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Fotografia ampliada"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setActiveImage(null);
            }
          }}
        >
          <div className="frame-real-gallery-modal__panel">
            <button
              type="button"
              className="frame-real-gallery-modal__close"
              onClick={() => setActiveImage(null)}
              aria-label="Cerrar"
            >
              <X aria-hidden="true" />
            </button>
            <img src={activeImage.src} alt={activeImage.alt} />
          </div>
        </div>
      )}
    </>
  );
}
